import React, {createRef} from "react";
import BaseComponent from "../../../../../lib/components/BaseComponent";
import GF from "../../../../../lib/utils/GF";
import VerticalLayout from "../../../../../lib/components/layouts/VerticalLayout";
import InputText from "../../inputFields/InputText";
import PropTypes from "prop-types";
import {TextField} from "@mui/material";
import Read from "../../../../../lib/model/service/entity/dto/Read";
import CM from "../../../../model/system/CM";
import CampaignService from "../../../../model/service/campaign/CampaignService";

class StepOverview extends BaseComponent {

  constructor(props) {
    super(props);
    this.refNumOfRecords = createRef();
    this.state = {refNumOfRecords: 'wird ermittelt ...'};
  }

  componentDidMount() {
    super.componentDidMount();

    if (this.props.data.query) {
      this.props.data.query.endRow = 1;
      let dtoRead = new Read(this.props.data.query);
      dtoRead.setProperties(CampaignService.createCampaignRedirectProperty(this.props.data.campaignId));

      CM.get().doJsonAjax(CM.get().getServiceUrl('DoctrineEntityService'), dtoRead, (response) => {
        this.props.data.query.endRow = 999999999999;
        if (response && response.success) {
          this.setState({
            refNumOfRecords: response.data.totalRows
          });
          this.onReadyChanged((response.data.totalRows === 0));
        }
      });
    } else {
      this.setState({
        refNumOfRecords: 'alle!!!'
      });
      this.onReadyChanged(false);
    }
  }

  onReadyChanged(haveNoRecords) {
    if (this.props.onReadyChanged) {
      this.props.onReadyChanged({nextStepButtonDisabled: haveNoRecords});
    }
  }

  render() {
    let listName = this.props.data.getMailingListName();
    let dateTime = GF.dateTimeToString(this.props.data.getDeliveryDateTime());
    let config = this.props.data.getConfiguration();
    let template = config.getTemplate();
    let sendMailText = config.getSendFromText();
    let sendMailAddress = config.getSendFromAddress();
    let notiz = this.props.data.getNotiz();
    return <VerticalLayout className='lg:flex-row gap-5'>
      <VerticalLayout className='gap-4'>
        <InputText disabled labelElement='Liste' defaultValue={listName}/>
        <InputText disabled labelElement='Datum' defaultValue={dateTime}/>
        <TextField label='Aktuelle Anzahl Datensätze' disabled value={this.state.refNumOfRecords}/>
      </VerticalLayout>
      <VerticalLayout className='gap-4'>
        <InputText disabled labelElement='Template' defaultValue={template}/>
        <InputText disabled labelElement='Absender Name' defaultValue={sendMailText}/>
        <InputText disabled labelElement='Absender Mailadresse' defaultValue={sendMailAddress}/>
      </VerticalLayout>
      <InputText minRows={7} multiline labelElement='Bemerkungen' disabled defaultValue={notiz}/>
    </VerticalLayout>;
  }
}

StepOverview.propTypes = {
  data: PropTypes.object,
  onReadyChanged: PropTypes.func
}
export default StepOverview;
